/** The first name in the account's display name, for the start page's
 *  greeting; null when there is no name, or the "name" is the e-mail
 *  address (some sign-ins only give that). Directories that store
 *  "Last, First" give the first word after the comma. */
export function firstNameOf(displayName: string | null | undefined): string | null {
  const name = (displayName ?? "").trim();
  if (!name || name.includes("@")) return null;
  const comma = name.indexOf(",");
  const given = comma >= 0 ? name.slice(comma + 1) : name;
  const word = given.trim().split(/\s+/)[0] ?? "";
  // No trailing punctuation: "Hi Lasse,, what …" reads as a typo.
  const clean = word.replace(/[\p{P}]+$/u, "");
  return clean || null;
}
